import { schema } from "normalizr";

export const integrationSchema = new schema.Entity("integrations", {});

export const integrationListSchema = [integrationSchema];

export const configurationSchema = new schema.Entity("configurations", {});

export const configurationListSchema = [configurationSchema];
